import { useTranslation } from "react-i18next";
import type { ItemKind } from "../../api/content/reviewDecoders";
import { appPaths } from "../../shared/routing/appPaths";
import AppButton from "../../ui/buttons/AppButton";
import { editIntent, useThreadPreparation } from "../threads/prepare";

/** Kinds the process library holds (AU-7). */
const PROCESS_KINDS: ReadonlySet<ItemKind> = new Set<ItemKind>(["prompt", "label_list", "step", "workflow", "tool", "skill", "artifact"]);

/**
 * A process item's action on its page (SB-16, F37): one Edit, which prepares work on this
 * exact version in the Thread view. There the user edits it by hand in its form, where it
 * has one, or with the agent.
 */
export default function ProcessItemActions({ projectId, kind, name, reference }: { projectId: string; kind: ItemKind; name: string; reference: string }) {
  const { t } = useTranslation();
  const preparation = useThreadPreparation();
  if (!PROCESS_KINDS.has(kind)) {
    return null;
  }
  return (
    <div className="flex flex-wrap items-center gap-2">
      <AppButton variant="primary" size="sm" title={t("authoring.item.editHint")} onClick={() => { preparation.prepare(editIntent(projectId, { itemKind: kind, name, reference }, appPaths.item(reference))); }}>
        {t("authoring.item.edit")}
      </AppButton>
    </div>
  );
}
